import { action, observable, makeObservable } from 'mobx';
import Storage from '../Storage';

class ViewStore {
  @observable companySelect = false;
  @observable drawerOpen = false;
  @observable showVat = true;

  @observable showLoginDialog = false;

  @observable snackbarOpen = false;
  @observable snackbarMessage;

  constructor() {
    makeObservable(this);
    const showVat = Storage.get('showVat');

    if (typeof showVat === 'boolean') {
      this.showVat = showVat;
    }
  }

  @action.bound
  closeDrawer() {
    this.drawerOpen = false;
    this.companySelect = false;
  }

  @action.bound
  openDrawer() {
    this.drawerOpen = true;
  }

  @action.bound
  hideSnackbar() {
    this.snackbarOpen = false;
  }

  @action.bound
  showSnackbar(message) {
    this.snackbarMessage = message;
    this.snackbarOpen = true;
  }

  @action.bound
  toggleVat() {
    this.showVat = !this.showVat;
    Storage.set('showVat', this.showVat);
  }

  @action.bound
  toggleCompanySelect() {
    this.companySelect = !this.companySelect;
  }

  // For log in to company
  // Opens the dialog
  @action.bound
  openLoginDialog() {
    this.showLoginDialog = true;
  }
  // Closes the dialog
  @action.bound
  closeLoginDialog() {
    this.showLoginDialog = false;
  }

}

export default new ViewStore();
